import { useNavigate } from "react-router-dom";
import { XCircle } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen grid place-items-center bg-gado-cream p-6">
      <div className="max-w-md w-full rounded-2xl border border-gado-line bg-white p-10 text-center" data-testid="payment-cancel-page">
        <XCircle size={64} className="mx-auto text-gado-muted mb-5" />
        <h1 className="font-cabinet text-2xl font-bold text-gado-ink">Pagamento cancelado</h1>
        <p className="text-gado-muted mt-2">Nenhuma cobrança foi feita. Você pode assinar quando quiser.</p>
        <div className="flex gap-3 mt-6">
          <Button variant="outline" onClick={() => navigate("/app")} className="flex-1">Painel</Button>
          <Button onClick={() => navigate("/app/upgrade")} className="flex-1 bg-gado-green hover:bg-gado-greenHover text-white">Ver planos</Button>
        </div>
      </div>
    </div>
  );
}
